import { render, staticRenderFns } from "./mybys-checkbox.vue?vue&type=template&id=b82a54fa&scoped=true&"
import script from "./mybys-checkbox.vue?vue&type=script&lang=js&"
export * from "./mybys-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./mybys-checkbox.vue?vue&type=style&index=0&id=b82a54fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82a54fa",
  null
  
)

export default component.exports